import { firstValueFrom } from 'rxjs';
import { PromptService } from '@services';
import { FuturesPosition } from '../../../../services/futures-data.service';

// FND warning window in days
export const FND_WARNING_DAYS = 60;

export interface PositionRow extends FuturesPosition {
  FuturesLabel: string; // e.g. 'Mar 2027'
  FuturesMonthName: string;
  ContractValue: number | null;
  DaysToFND: number | null;
  PositionStatus: 'Open' | 'Partial' | 'Closed';
  Reference: string; // 'Reserve 334719' or 'FC-12'
  FileRef: string;   // '334719' or 'FC-12'
  ApplicationDisplay: string;
}

export function daysUntil(date: string | null): number | null {
  if (!date) return null;
  const target = new Date(date.substring(0, 10) + 'T00:00:00');
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / 86400000);
}

// catches a per-lb price typed on a per-MT exchange and the reverse
export function priceUnitWarning(price: number | null | undefined, unit: string | null | undefined): string | null {
  if (price == null || String(price) === '' || Number(price) <= 0) return null;
  const p = Number(price);
  if (unit === 'MT' && p < 100) {
    return `This exchange is priced per metric ton (usually thousands, e.g. 4,500). ${p} per MT is ${(p / 2204.62262).toFixed(4)} per lb.`;
  }
  if (unit !== 'MT' && p > 20) {
    return `This exchange is priced per lb (e.g. 2.45). ${p} per lb looks like a per-ton price.`;
  }
  return null;
}

export async function confirmPrice(prompt: PromptService, warning: string): Promise<boolean> {
  const { closed$ } = prompt.open({
    promptText: `${warning} Save this price anyway?`,
    buttons: [
      { label: 'Save anyway', value: true, buttonClass: 'btn-bg-green' },
      { label: 'Fix price', value: false, buttonClass: 'btn-bg-red' }
    ]
  });
  return !!(await firstValueFrom(closed$));
}

export function fndClass(days: number | null): string {
  if (days === null) return '';
  if (days < 0) return 'fnd-past';
  return days <= FND_WARNING_DAYS ? 'fnd-warning' : '';
}
